import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { MatPaginator } from '@angular/material/paginator'
import { MatTableDataSource } from '@angular/material/table'
import { Subject, takeUntil } from 'rxjs'
import { AyBService } from 'src/app/services/api/ayb.service'
import { DialogInventarioMenajeriaComponent } from './dialog-inventario-menajeria/dialog-inventario-menajeria.component'
@Component({
  selector: 'app-inventario',
  templateUrl: './inventario.component.html',
  styleUrls: ['./inventario.component.scss']
})
export class InventarioComponent implements OnInit, OnDestroy {
  private _unsubscribeOnDestroy$: Subject<boolean> = new Subject<boolean>()

  menajeria: any = []
  m: any

  displayedColumns: string[] = [
    // 'id',
    'nombre',
    'marca',
    'modelo',
    'cantidad',
    'proveedor',
    'ruc',
    'numFactura',
    'modificar'
    // 'eliminar'
  ]

  dataSource: MatTableDataSource<any[]> = new MatTableDataSource<any[]>([])
  loading: boolean = true

  @ViewChild(MatPaginator) paginator!: MatPaginator

  constructor (
    public dialog: MatDialog,
    private readonly alimentosService: AyBService
  ) {}

  ngOnInit (): void {
    this.dataSource = new MatTableDataSource()
    this.getAllMenajeria()
  }

  ngOnDestroy (): void {
    this._unsubscribeOnDestroy$.next(true)
    this._unsubscribeOnDestroy$.complete()
  }
  getAllMenajeria () {
    this.alimentosService
      .queryGetAllMenajeria()
      .pipe(takeUntil(this._unsubscribeOnDestroy$))
      .subscribe((response: any) => {
        this.menajeria = response.getAllMenajeria
        this.dataSource.data = this.menajeria
        this.dataSource.paginator = this.paginator
        this.loading = false
        return response
      })
  }

  applyFilter (event: Event) {
    const filterValue = (event.target as HTMLInputElement).value
    this.dataSource.filter = filterValue.trim().toLowerCase()
  }

  openDialogModify (i: any): void {
    console.log(i)
    let dialogConfig = new MatDialogConfig()
    this.alimentosService
      .queryGetMenajeria(i)
      .pipe(takeUntil(this._unsubscribeOnDestroy$))
      .subscribe((response: any) => {
        this.m = response.getMenajeria

        dialogConfig.data = {
          id: this.m.id,
          nombre: this.m.nombre,
          marca: this.m.marca,
          modelo: this.m.modelo,
          cantidad: this.m.cantidad,
          razonSocial: this.m.factura?.razonSocial,
          ruc: this.m.factura?.ruc,
          numFactura: this.m.factura?.numFactura,
          title: 'Modificar Artículo',
          estado: 1
        }
        dialogConfig.width = '40rem'

        let dialogRef = this.dialog.open(
          DialogInventarioMenajeriaComponent,
          dialogConfig
        )

        dialogRef
          .afterClosed()
          .pipe(takeUntil(this._unsubscribeOnDestroy$))
          .subscribe(result => {
            if (result == 1) {
              this.getAllMenajeria()
            }
          })
      })
  }
  openDialogAdd (): void {
    let dialogConfig = new MatDialogConfig()
    dialogConfig.data = {
      nombre: '',
      marca: '',
      modelo: '',
      cantidad: '',
      razonSocial: '',
      ruc: '',
      numFactura: '',
      title: 'Agregar Menajeria',
      estado: 2
    }
    dialogConfig.width = '40rem'

    let dialogRef = this.dialog.open(
      DialogInventarioMenajeriaComponent,
      dialogConfig
    )

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this._unsubscribeOnDestroy$))
      .subscribe(result => {
        if (result == 1) {
          this.getAllMenajeria()
        }
      })
  }
}
